import { Component, OnInit } from '@angular/core';
import { TipoMenu } from 'src/app/_enums/TipoMenu';

@Component({
  selector: 'app-home-page-mov',
  templateUrl: './home-page-mov.component.html'
})
export class HomePageMovComponent implements OnInit {

  public tipoMenuValue: number = TipoMenu.Mov;

  constructor() { }

  ngOnInit() {
  }
}